<div class="card-spacer">
  <div class="model-content-dashboard">
    <div class="modal-header">
      <p class="modal-title dot-dot-dot">{{ partnerCode }} - {{ partnerName }}</p>
    </div>

    @if (!show) {
      <app-loading-spinner style="min-height: 270px; position:relative;"></app-loading-spinner>
    }
    <app-dashboard-error [hasError]="hasError" [minHeight]="'270px'" (reload)="reloadClaims()"></app-dashboard-error>

    @if (show && !hasError) {
      <div class="modal-body">
        <div class="modal-subtitle">Claims ready for commercial acceptance</div>
        <br>
          <div class="key-value left-margin">
            <div class="table-header">Packcenter</div>
            <div class="table-header">#Claims</div>
          </div>
          @for (claim of claimsDashboard.ready; track claim) {
            <div class="key-value left-margin">
              <span>{{ claim.sppCode }} - {{ claim.sppName }}</span>
              <span>{{ claim.amount }}</span>
            </div>
          }
          @if (claimsDashboard.ready.length == 0) {
            <div class="key-value left-margin">
              <span>-</span>
              <span>-</span>
            </div>
          }
          <br>
            <div class="modal-subtitle">Submitted, but not transferred to Supplying packing plant</div>
            <br>
              <div class="key-value left-margin">
                <div class="table-header">SPP</div>
                <div class="table-header">Claim number</div>
              </div>
              @for (claim of claimsDashboard.submitted; track claim) {
                <div class="key-value left-margin">
                  <span>{{ claim.sppCode }} - {{ claim.sppName }}</span>
                  <span>{{ claim.claimNumber }}</span>
                </div>
              }
              @if (claimsDashboard.submitted.length == 0) {
                <div class="key-value left-margin">
                  <span>-</span>
                  <span>-</span>
                </div>
              }
            </div>
          }
        </div>
      </div>